<template>
    <div>
         <lk-auto-complete
            clearable
            v-if="ifAble"
            ref="contact"
            @on-change="handleChange"
            v-model.trim='contactInfo'
            @on-focus="handleFirst"
            @on-select="handleSeleced"
            placeholder="可通过联系人姓名搜索">
            <div class="test1" v-if='contactList.length'>
              <lk-option v-for="(item,index) in contactList" :value="item.id" :key="index">{{`${item.name}-${item.phone}`}}</lk-option>
            </div>
            <div v-if="isEmpty" class="nodata">
              暂无数据
            </div>
        </lk-auto-complete>
    </div>
</template>
<script>
import utils from '../../libs/utils.js';
import base from '../../services/base';

export default {
  data() {
    return {
      contactList: [],
      contactInfo: '',
      firstFocus: true,
      selectStatus: false,
      isEmpty: false,
    };
  },
  props: {
    contactData: {
      type: String,
    },
    ifAble: {
      type: Boolean,
    },
  },
  model: {
    prop: 'contactData',
    event: 'change',
  },
  methods: {
    getData() {
      this.$store.commit('setDisableLoading', true);
      this.isEmpty = false;
      if (this.selectStatus) {
        this.selectStatus = false;
        return;
      }
      this.contactList = [];
      const params = {
        contactInfo: this.contactInfo,
      };
      base.goods.getConcactList(params).then((res) => {
        if (res.data.status === 200) {
          this.contactList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleFirst() {
      if (this.firstFocus) {
        this.getData();
      }
      this.firstFocus = false;
    },
    handleChange: utils.debounce(
      function a() {
        if (this.contactInfo.length > 20) {
          this.$Message.error('输入内容不超过20个字符');
          this.$emit('change', '');
        } else {
          this.$emit('change', this.contactInfo);
        }
        this.getData();
      }, 500,
    ),
    handleSeleced(val) {
      this.selectStatus = true;
      this.contactList.forEach((item) => {
        if (item.id === val) {
          this.$nextTick(() => {
            this.contactInfo = item.name;
          });
          this.$emit('contactValue', item.phone);
          this.contactList = [];
          this.isEmpty = false;
        }
      });
    },
  },
  watch: {
    contactData(val) {
      this.contactInfo = val;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
/deep/ .ivu-auto-complete.ivu-select-dropdown {
    max-height: 250px;
}
.test1 {
  max-height: 100px;
  position: relative;
  overflow: auto;
}
.nodata {
  color: #9a9a9a;
  font-size: 14px;
  padding: 4px 0 4px 4px;
}
</style>
